import { Col, Row } from 'react-bootstrap';
import { BarChartFill, CartFill, Collection, Controller, Search, Shuffle } from "react-bootstrap-icons";
import { useTranslation } from 'react-i18next';
import { redirectToLoginUri } from '../../functions/authentication';
import { authEndpoint } from '../../functions/endpoint';
import PageLayout from '../PageLayout';
import './Home.css';

const FEATURES = [
    { key: 'games',    icon: Collection,   color: '#6d28d9' },
    { key: 'search',   icon: Search,       color: '#7c3aed' },
    { key: 'buy',      icon: CartFill,     color: '#5b21b6' },
    { key: 'extract',  icon: Shuffle,      color: '#4f46e5' },
    { key: 'sessions', icon: Controller,   color: '#0f766e' },
    { key: 'stats',    icon: BarChartFill, color: '#0369a1' },
];

function Home({ token }) {
    const { t } = useTranslation('messages');

    return (
        <PageLayout
            hero={
                <>
                    <h1 className="display-4 fw-bold mb-3">{t('main.home.title')}</h1>
                    <p className="lead text-white-50 mb-4">{t('main.home.subtitle')}</p>
                    {!token && (
                        <button className="btn btn-light btn-lg fw-semibold px-4" onClick={() => redirectToLoginUri(authEndpoint)}>
                            {t('main.home.cta_login')}
                        </button>
                    )}
                </>
            }
            heroCenter
            mainPadding="py-5"
        >
            <Row className="g-4 justify-content-center">
                {FEATURES.map(({ key, icon: Icon, color }) => (
                    <Col key={key} xs={12} sm={6} md={4}>
                        <div className="card border-0 shadow-sm h-100">
                            <div className="card-body d-flex flex-column align-items-center text-center p-4">
                                <div
                                    className="rounded-circle d-flex align-items-center justify-content-center mb-3"
                                    style={{ width: 72, height: 72, backgroundColor: color, color: '#fff' }}
                                >
                                    <Icon size={36} />
                                </div>
                                <h5 className="fw-semibold mb-2">{t(`main.home.feature_${key}_title`)}</h5>
                                <p className="text-muted mb-0">{t(`main.home.feature_${key}_description`)}</p>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>
            <Row className="justify-content-center mt-5">
                <Col xs="auto" className="text-center">
                    <a href="https://boardgamegeek.com" target="_blank" rel="noreferrer">
                        <img src="/images/powered_by_BGG_01_SM.png" alt="Powered by Board Games Geek" />
                    </a>
                </Col>
            </Row>
        </PageLayout>
    );
}

export default Home;
